<template>
    <div style="width:100%; height: 100%;background-image: url('/img/bgd-banner.jpg')">
        <br/>
        <p class="text-center white--text display-2 pt-10">Response Received</p>
        </br>
        <div class="text-center">
            <v-btn
                color="hubblue"
                class="white--text"
                style="width: 7em; height: 3em; font-size: 4em;"
                @click.prevent="login()"
                data-cy="btnLogin"
            >Go To Login</v-btn>
        </div>
        <br />
        <br />
    </div>
</template>


<script>
export default {
    data() {
        return {}
    },
    methods: {
        login() {
            this.$router.push('/login')
        }
    }
}
</script>
